<script lang="ts">
  import { DateTime } from "../lib/date-time";
  import type { Calender } from "../lib/calender";
  import type { SelectionState, SelectionRange } from "../lib/range";
  import { Availabilities, Possibility } from "../availability/availability-provider";
  import { DatePickerTranslations } from "../DatePicker.i18n";
  import Panel from "../Panel.svelte";
  import PanelWeeks from "../PanelWeeks.svelte";

  export let selection: SelectionRange;
  export let calender: Calender;
  export let availabilities: Availabilities;
  export let language: string;

  const today = DateTime.today;

  $: panels = calender.panels;

  let selectionState = selection.getState();
  $: selectionInvalid = isSelectionInvalid($selectionState, availabilities);

  $: T = DatePickerTranslations(language);

  function isSelectionInvalid(state: SelectionState, availabilities: Availabilities) {
    const { from, to, complete } = state;
    return complete && (availabilities.isArrivalPossible(from) !== Possibility.Possible || availabilities.isDiparturePossible(from, to) !== Possibility.Possible);
  }
</script>

{#each $panels as panel}
  <Panel on:prev={(_) => calender.prevMonth()} on:next={(_) => calender.nextMonth()} on:back>
    <div slot="header">
      {T.get("getMonthName", panel.month)}
      {panel.year}
    </div>
    <div class:lrs-selection-invalid={selectionInvalid}>
      <PanelWeeks {calender} {panel} {availabilities} {selection} {language} {today} />
    </div>
  </Panel>
{/each}
